import scienceDeck from '../../data/science.json';
import historyDeck from '../../data/history.json';
import geographyDeck from '../../data/geography.json';
import math1Deck from '../../data/math1.json';
import frenchDeck from '../../data/french.json';
import hindiDeck from '../../data/hindi.json';
import mandarinDeck from '../../data/mandarin.json';
import spanishDeck from '../../data/spanish.json';

const defaultDecks = [
  geographyDeck,
  historyDeck,
  math1Deck,
  scienceDeck,
  frenchDeck,
  hindiDeck,
  mandarinDeck,
  spanishDeck,
];

const slugify = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const buildDefaultStudyData = () => {
  const groups = [];
  const flashcards = [];

  defaultDecks.forEach((deck) => {
    if (!Array.isArray(deck.cards)) return;

    deck.cards.forEach((difficultyGroup) => {
      if (!difficultyGroup || !Array.isArray(difficultyGroup.cards) || difficultyGroup.cards.length === 0) {
        return;
      }

      const topic = deck.topic;
      const difficulty = difficultyGroup.difficulty;
      const groupId = `group-${slugify(topic)}-${slugify(difficulty)}`;
      const cardIds = [];

      difficultyGroup.cards.forEach((card, index) => {
        if (!card?.question || !card?.answer || !card?.incorrect) return;

        const cardId = `card-${slugify(topic)}-${slugify(difficulty)}-${index + 1}`;
        cardIds.push(cardId);
        flashcards.push({
          id: cardId,
          question: card.question,
          answer: card.answer,
          incorrect: card.incorrect,
          groupId,
          difficulty,
          createdAt: new Date().toISOString(),
          reviewed: false,
          lastReviewed: null,
          correctCount: 0,
          incorrectCount: 0,
          lastAnsweredCorrect: null,
        });
      });

      if (cardIds.length === 0) return;

      groups.push({
        id: groupId,
        name: `${topic} - ${difficulty}`,
        topic,
        difficulty,
        createdAt: new Date().toISOString(),
        cardIds,
      });
    });
  });

  groups.sort((a, b) => {
    const topicCompare = a.topic.localeCompare(b.topic);
    if (topicCompare !== 0) return topicCompare;
    return a.difficulty.localeCompare(b.difficulty);
  });

  return {
    flashcards,
    groups,
    activeGroupId: groups[0]?.id || null,
  };
};
